import { render, staticRenderFns } from "./JewelleryDashboard.vue?vue&type=template&id=18aeabc2&scoped=true&"
import script from "./JewelleryDashboard.vue?vue&type=script&lang=js&"
export * from "./JewelleryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./JewelleryDashboard.vue?vue&type=style&index=0&id=18aeabc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aeabc2",
  null
  
)

export default component.exports